exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card__subtitle,.v-card__text{font-size:1rem;font-weight:500;line-height:1.375rem;letter-spacing:.0071428571em}.v-stepper__content{max-height:700px;overflow-y:scroll}.v-stepper__content h2{font-weight:500;margin-top:24px;font-size:1.2em}.v-stepper__content .input-row:not(:first-child){border-top:1px solid #d3d3d3;margin-top:24px}", ""]);

// exports
